export const getUserTypeFromToken = (token) => {
  if (!token) return null;
  return 'ADMINISTRATOR';
  // return 'ADMIN_USER';
};

export const transformProfile = (raw) => ({
  id: raw.uuid,
  name: ((raw.email_address || '').split('@')[0] || 'User').toUpperCase(),
  email_address: raw.email_address || '- no email -',
  env_mode: raw?.environment_type,
  is_first_time: +raw?.user?.is_first_time_login === 1,
});

const MAP_ENVIRONMENT_TYPE = {
  TEST: 'Test',
  PROD: 'Production',
};

export const transformAccount = (raw) => ({
  id: raw?.uuid,
  name: raw?.name || 'Untitled',
  label: `${raw?.name} (${
    MAP_ENVIRONMENT_TYPE[raw?.environment_type] || raw?.environment_type
  })`,
  logo: raw?.logo,
  env_mode: raw?.environment_type,
  is_active: raw?.status === 'ACTIVE',
  role: raw?.role?.name,

  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const payloadAccount = (payload) => ({
  name: payload.name,
  logo: payload.logo,

  bank_name: payload.bank_name,
  bank_account_number: payload.bank_account_number,
  bank_account_name: payload.bank_account_name,
});
